import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MarkdownPipe } from '../../pipes/markdown.pipe';
import { Artifact } from '../../models/artifact.model';

/**
 * Renders an artifact whose report IS its markdown body (SF Account Summary,
 * NEAT Deal Analysis, PCheck prep-doc blurb). Registered under type 'markdown'
 * in ARTIFACT_RENDERERS. The panel supplies `artifact`; file actions
 * (open/download) live in the panel header, not here.
 */
@Component({
  selector: 'app-markdown-artifact',
  standalone: true,
  imports: [MarkdownPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (artifact.body) {
      <div class="artifact-prose" [innerHTML]="artifact.body | markdown"></div>
    } @else {
      <p class="artifact-empty">This report has no preview. Use the buttons above to open or download it.</p>
    }
  `,
  styleUrls: ['./markdown-artifact.component.scss'],
})
export class MarkdownArtifactComponent {
  @Input() artifact!: Artifact;
}
